module.exports = __webpack_public_path__ + "img/grin.c178ee89.svg";